<template>
    <!-- 영업기회 이력 조회 -->
    <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
            <h2 class="accordion-header">
                <ElButton 
                    type="accordionHeader" 
                    target="panelsStayOpen-collapse-optyHistory"
                >
                    영업기회 이력
                </ElButton>
            </h2>
            <div id="panelsStayOpen-collapse-optyHistory" class="accordion-collapse collapse">
                <div class="accordion-body accordion-body-register">
                    <!-- 엑셀 다운 -->
                    <div class="d-flex justify-content-between">
                        <div></div>
                        <div class="table-btn-group d-flex align-items-center">
                            <ElButton type="excelDownload" @buttonClick="optyHistExcelDown()">엑셀다운</ElButton>
                        </div>
                    </div>

                    <!-- 테이블 리스트 -->
                    <div class="table-list">
                        <DataTable
                            :value="optyHistDataList.optyHistRowData"
                            paginator
                            :rows="rowsPerPage"
                            :rowsPerPageOptions="[10, 20, 50, 100, 200]"
                            :pt="{
                                wrapper : {style:'height : 600px'},
                                column: {
                                    bodycell: ({ state }) => ({
                                        class: [{ 'pt-0 pb-0': state['d_editing'] }]
                                    })
                                }
                            }"
                             @page="(event) => (currentPage = event.page)"
                        >
                            <template #empty>
                                <div>데이터가 존재하지 않습니다.</div>
                            </template>
                            <Column
                                v-for="optyHist in optyHistGridColumn"
                                :key="optyHist.field"
                                :field="optyHist.field"
                                :header="optyHist.header"
                                :style = "optyHist.style"                              
                            >
                                <template #body="{data,field,index}">
                                    <div :style="getStyle(data, field, index)">
                                       <div v-if="field == 'gm_amt_per'">
                                            {{data[field] }}
                                        </div> 

                                        <div v-else-if="field == 'sales_nm'">
                                            <span class="elip-div2" v-tooltip.bottom="data[field]">{{ getSummaryData(data[field])}}</span>
                                        </div>

                                        <div v-else-if="field == 'end_user_cmp_nm'">
                                            <span class="elip-div2"  v-tooltip.bottom="data[field]">{{ getSummaryData(data[field])}}</span>
                                        </div>

                                        <div v-else-if="field == 'gm_amt'">
                                            {{numberFomat(data[field]) }}
                                        </div>

                                        <div v-else-if="field == 'sales_cmp_nm'">
                                            <span class="elip-div2"  v-tooltip.bottom="data[field]">{{ getSummaryData(data[field])}}</span>
                                        </div>

                                        <div v-else-if="field.includes('sum')">
                                            <span> {{ numberFomat(data[field])}} </span>
                                        </div>

                                        <div v-else-if="field == 'stage_nm'">
                                            <span :class="getStageOptionStyle(data.stage_cd)">{{ data.stage_nm }}</span>
                                        </div>

                                        <div v-else-if="field == 'action'">
                                            <span :class="getActionOptionStyle(data.action)">{{ data.action }}</span>
                                        </div>

                                        <span v-else class="elip-div2">{{ data[field] }}</span>
                                    </div>
                                </template>
                            </Column>
                        </DataTable>
                    </div> 
                </div>
            </div>
        </div>
    </div>

    <ExcelManage
        v-show="false"
        ref="optyHistExcelManageRef"
        @return="r => getExcelData(r.sheets)"
    />
</template>

<script setup>
import common from "@/js/common";

import ExcelManage from '@/components/common/MCO_EX_001.vue';
import DataTable from "primevue/datatable";

import { useLoading } from '@/composable/Loading.js'
import {  salesOptyHistList, salesOptySelect } from '@/api/sales';
import { reactive,onBeforeMount,ref } from 'vue';
import Column from "primevue/column";

const { setIsLoading } = useLoading()

/*변수 Start*/
const optyHistExcelManageRef = ref()
const rowsPerPage = ref(10); // 페이지당 데이터 수
const currentPage = ref(0); // 현재 페이지 번호
const optyHistDataList = reactive({
    // 원본 이력 데이터
    optyHistRowData : []
})

// api 통신을 위해 사용하는 조회 조건
const searchOptyHistParams = reactive({
    ims_seq : '',
    opty_seq : '',
})

//매입매출 이력 조회 헤더
const optyHistGridColumn = ref([
    { header: "이력 생성 동작", field: "action", style: { textAlign: "center", minWidth: "130px" }, sortable: true },
    { header: "이력 생성 일자", field: "reg_dt", style: { textAlign: "center", minWidth: "140px" }, sortable: true },
    { header: "영업기회명", field: "sales_nm", style: { textAlign: "left", minWidth: "150px" }, sortable: true },
    { header: "EndUser", field: "end_user_cmp_nm", style: { textAlign: "left", minWidth: "150px" }, sortable: true },
    { header: "매출처", field: "sales_cmp_nm", style: { textAlign: "left", minWidth: "150px" }, sortable: true },
    { header: "담당자1", field: "manager1", style: { textAlign: "center", minWidth: "90px" }, sortable: true },
    { header: "담당자2", field: "manager2", style: { textAlign: "center", minWidth: "90px" }, sortable: true },
    { header: "영업대표", field: "sales_ceo", style: { textAlign: "center", minWidth: "100px" }, sortable: true },
    { header: "Bridge(B), Risk(R)", field: "bnr_nm", style: { textAlign: "center", minWidth: "100px" }, sortable: true },
    { header: "Stage", field: "stage_nm", style: { textAlign: "center", minWidth: "80px" }, sortable: true },
    { header: "우선협상자 선정일(Won_Date)", field: "won_dt", style: { textAlign: "center", minWidth: "150px" }, sortable: true },
    { header: "PO 발행일", field: "po_dt", style: { textAlign: "center", minWidth: "120px" }, sortable: true },
    { header: "고객 PO#", field: "custom_po", style: { textAlign: "right", minWidth: "70px" }, sortable: true },
    { header: "상품(납품)정보", field: "prd_info", style: { textAlign: "center", minWidth: "110px" }, sortable: true },
    { header: "납품 완료일", field: "dlv_dt", style: { textAlign: "center", minWidth: "120px" }, sortable: true },
    { header: "PSP 지정여부", field: "psp_yn", style: { textAlign: "center", minWidth: "100px" }, sortable: true },
    { header: "검수완료일", field: "isp_dt", style: { textAlign: "center", minWidth: "120px" }, sortable: true },
    { header: "Waranty 영업기회 매핑", field: "w_sales_id", style: { textAlign: "center", minWidth: "190px" }, sortable: true },
    { header: "Waranty End Date", field: "w_end_dt", style: { textAlign: "center", minWidth: "120px" }, sortable: true },
    { header: "총 매출금액(원)", field: "outcome_sum", style: { textAlign: "right", minWidth: "140px" }, sortable: true },
    { header: "총 매입금액(원)", field: "income_sum", style: { textAlign: "right", minWidth: "140px" }, sortable: true },
    { header: "Gm Amount(원)", field: "gm_amt", style: { textAlign: "right", minWidth: "160px" }, sortable: true },
    { header: "GM(%)", field: "gm_amt_per", style: { textAlign: "center", minWidth: "70px" }, sortable: true },
    { header: "즐겨찾기 여부", field: "bkmark_yn", style: { textAlign: "center", minWidth: "100px" }, sortable: true },
    { header: "수정자", field: "upd_user_nm", style: { textAlign: "center", minWidth: "90px" }, sortable: true }
])
/*변수 End*/

onBeforeMount(async()=>{
    let param = history.state;
    if(param.ims_seq){
        searchOptyHistParams.ims_seq = param.ims_seq
        searchOptyHistParams.opty_seq = null
    }else if(param.opty_seq){
        searchOptyHistParams.opty_seq = param.opty_seq
        searchOptyHistParams.ims_seq = null
    }else{
        alert('잘못된 접근입니다.')
        router.go(-1)
    }
    await getOptyHist()
})

const getGlobalIndex = (localIndex) => {
  return currentPage.value * rowsPerPage.value + localIndex;
};

const getStyle=(data, field,index) =>{
    if(!data) return {};
    if ( field == 'reg_dt' || field =='action' || field =='opty_hist_seq') return {};
    const globalIndex = getGlobalIndex(index); // 전체 인덱스 계산
    const prevData =optyHistDataList.optyHistRowData[globalIndex + 1];

    if (prevData) {
        if (prevData[field] !== data[field]) {
            return { backgroundColor: "yellow", fontWeight: "bold" }; // 변경된 데이터 강조
        }
    }
    return {};
}


//매입매출 이력 조회
const getOptyHist = async()=>{
    try{
        setIsLoading(true)
        if(searchOptyHistParams.ims_seq){
            const res = await salesOptySelect(searchOptyHistParams)
            if(res.rtn.iopty_seq){
                searchOptyHistParams.opty_seq = res.rtn.iopty_seq
            }
        }
        let searchParams = {
            opty_seq: searchOptyHistParams.opty_seq
        }
        const res = await salesOptyHistList(searchParams)
        let resList = [...res.rtn]
        optyHistDataList.optyHistRowData = resList.map((item,index)=>{
            item.index = index
            Object.keys(item).forEach((key)=>{
                if(key.includes('_dt')){
                    if(item[key] !== '0000-00-00'){
                        item[key] = item[key] || ''
                    }else{
                        item[key] = ''
                    }
                }

                if(key == 'reg_dt'){
                    item[key] = formatHistDate(item[key])
                }else if(key === 'custom_po')  {
                    const zeroWidthChar = '\u200C';
                    item[key] = `${zeroWidthChar}${item[key]}`;
                }else if(key === 'action') {
                    if(item[key] == 'C'){
                        item[key] = '생성'
                    }else if(item[key] == 'U'){
                        item[key] = '수정'
                    }else if(item[key] == 'D'){
                        item[key] = '삭제'
                    }
                }else if (key === 'gm_amt_per') {
                    item[key] = `${isFinite(Number(item[key])) ? Number(item[key]).toFixed(1) : 0}%`;
                }
            })
            return item
        })      
    } catch(err) {
        console.error(err)
    } finally {
        setIsLoading(false)
    }
}

//영업기회 이력 목록 다운로드
const optyHistExcelDown = ()=>{
    let fileNm = '영업기회 이력 목록'
    let inoutList = optyHistDataList.optyHistRowData;
    let header = [
        { header: "이력 생성 일자", key: "reg_dt"},
        { header: "영업기회명", key: "sales_nm"},
        { header: "EndUser", key: "end_user_cmp_nm"},
        { header: "매출처", key: "sales_cmp_nm"},
        { header: "담당자1", key: "manager1"},
        { header: "담당자2", key: "manager2"},
        { header: "영업대표", key: "sales_ceo"},
        { header: "Bridge(B), Risk(R)", key: "bnr_nm"},
        { header: "Stage", key: "stage_nm"},
        { header: "우선협상자 선정일(Won_Date)", key: "won_dt"},
        { header: "PO 발행일", key: "po_dt"},
        { header: "고객 PO#", key: "custom_po"},
        { header: "상품(납품)정보", key: "prd_info"},
        { header: "납품 완료일", key: "div_dt"},
        { header: "PSP 지정여부", key: "psp_yn"},
        { header: "검수완료일", key: "isp_dt"},
        { header: "Waranty 영업기회 매핑", key: "w_sales_id"},
        { header: "Waranty End Date", key: "w_end_dt"},
        { header: "총 매출금액", key: "outcome_sum"},
        { header: "총 매입금액", key: "income_sum"},
        { header: "Gm Amount", key: "gm_amt"},
        { header: "GM%", key: "gm_amt_per"},      
        { header: "즐겨찾기 여부", key: "bkmark_yn"},
        { header: "이력 생성 동작", key: "action"},
        { header: "수정자", key: "upd_user_nm"}
    ]
    let headerProps = optyHistGridColumn.value.map((item)=>{
        return item.field
    })
    optyHistExcelManageRef.value.excelDownload(fileNm,header,inoutList,headerProps)
}

/*데이터 편집 메서드 Start*/
// 긴 문자열 값 자르기
const getSummaryData = (item) => {
    let summaryData = item.length > 13 ? item.slice(0, 13) + " ..." : item;
    return summaryData
}

// 숫자 포맷 맞추기
function numberFomat(number){
    if(number){
        return number = common.checkNumberComma(number)
    }
    return number
}

const getStageOptionStyle = (item) => {
    const stageValue = item
    let classNm = ''
    if (stageValue == 'STG01') {
        classNm = 'stage stage-pipeline';
    } else if (stageValue == 'STG02') {
        classNm = 'stage stage-upside';
    } else if (stageValue == 'STG03') {
        classNm = 'stage stage-commit';
    } else if (stageValue == 'STG04') {
        classNm = 'stage stage-won';
    } else if (stageValue == 'STG05') {
        classNm = 'stage stage-close';
    } else if (stageValue == 'STG06') {
        classNm = 'stage stage-omit';
    } else if (stageValue == 'STG07') {
        classNm = 'stage stage-lost';
    }
    return classNm
}

// 클래스 옵션 설정
const getActionOptionStyle = (item) => {
    const stageValue = item
    let classNm = ''
    if (stageValue == '생성') {
        classNm = 'stage stage-close';
    } else if (stageValue == '수정') {
        classNm = 'stage stage-won';
    } else if (stageValue == '삭제') {
        classNm = 'stage stage-pipeline';
    }
    return classNm
}

// 이력 생성 일자 시,분,초 붙이기
const formatHistDate = (item) => {
    const formattedDate = item.replace(
        /(\d{4}-\d{2}-\d{2}) (\d{2}):(\d{2}):(\d{2})/,
        (_, date, hour, minute, second) => `${date}  ${hour}시 ${minute}분 ${second}초`
    );
    return formattedDate
}
/*데이터 편집 메서드 End*/

</script>